var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[(_vm.debugMode)?_c('div',{staticClass:"debug-badge"},[_vm._v("Debug Mode")]):_vm._e(),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }